import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import update from 'immutability-helper'
import TSelectForm from "../../common/TSelectForm";

class SupportersForm extends Component {

    componentDidMount() {
        const { plugin, onChange } = this.props
        if (!plugin.active) {
            onChange({
                setting: {
                    useMobileEmbleCheck: ''
                },
                validated: true
            })
        }
    }

    @autobind
    handleSelect(item) {
        const { onChange, data } = this.props
        onChange(update(data, {
            setting: {
                useMobileEmbleCheck: {
                    $set: item.value
                },
            }
        }))
    }

    render() {
        const { plugin, data, year, mobile } = this.props
        return (
            <div className="desc_plugin45">
                <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />

                <div className="info_plugin">
                    { mobile &&
                        <div className="item_set item_sub">
                            우수블로그 모바일 배지를

                            <TSelectForm className="opt_set opt_plugin1" items={[
                                { label:'사용합니다.', value:'on' },
                                { label:'사용하지 않습니다.', value:'' },
                            ]} selected={data.setting.useMobileEmbleCheck} onSelect={this.handleSelect} />
                        </div>
                    }
                    <div className="item_set item_sub">
                        스킨 치환자는 <span className="txt_em">[##_{year}_##]</span>
                        입니다.
                    </div>
                </div>
                {this.props.saveButton()}
            </div>
        )
    }
}

SupportersForm.propTypes = {
    year: PropTypes.string.isRequired,
    mobile: PropTypes.bool.isRequired,
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default SupportersForm
